// src/design-system/components/Textarea/Textarea.tsx
import React from 'react';
import styles from './Textarea.module.css';

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  placeholder?: string;
  rows?: number;
  disabled?: boolean;
  error?: boolean;
  className?: string;
}

const Textarea: React.FC<TextareaProps> = ({ 
  value,
  onChange,
  placeholder = '',
  rows = 4,
  disabled = false,
  error = false,
  className = '',
  ...props 
}) => {
  const stylesRecord = styles as Record<string, string>;
  return (
    <textarea
      className={`${stylesRecord['textarea'] || ''} ${error ? (stylesRecord['error'] || '') : ''} ${className}`}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      rows={rows}
      disabled={disabled}
      {...props}
    />
  );
};

export default Textarea;

